"use client";
import React, { useEffect, useState } from "react";
import get from "lodash/get";

import Multimedia from "@stadium/ui/src/components/multimedia/multimedia";
import { UpdateInnerHtml } from "@stadium/helpers/html";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import TextOnlyContainer from "@sendmagic/prismic-nextjs/src/components/TextOnlyContainer";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

const defaultObj = {};

const TextWithLeftImage = ({ doc, StartOrderBtn }) => {
  const [innerHTML, setInnerHTML] = useState(null);
  const {
    title,
    description,
    image: { url: imgSrc = "", alt: imgAlt = "" } = defaultObj,
    img_link: { url: imgLink = "", target: imgTarget = "" } = defaultObj,
    video,
    internal_link_id,
    height,
    width,
    media,
    header_text,
  } = doc?.primary || defaultObj;
  const useHeight = height || video?.height;
  const useWidth = width || video?.width;

  useEffect(() => {
    setInnerHTML(
      UpdateInnerHtml(video.html, {
        height: useHeight,
        width: useWidth,
        loading: "lazy",
        class: "lazyload",
      }),
    );
  }, [useHeight, useWidth, video.html]);

  return (
    <div className="text-with-image-slice">
      <div className="container-width">
        {checkContentPresence(header_text) && (
          <div className="sns-h2 text-theme-primary text-center text-with-image-slice-title">
            {textResolver(header_text)}
          </div>
        )}
        <div className="row no-gutters text-with-image-section prismic-slice">
          <div className="col-lg-5 col-md-6 mx-auto order-1 text-with-image-content-block text-with-left-image-content">
            {internal_link_id && (
              <span id={internal_link_id} className="scroll-point position-absolute d-block" />
            )}
            <div className="px-xl-5 px-2xl-5 p-md-4 p-2xl-4 px-4 py-2 d-flex align-items-center text-with-image-content">
              <div className="px-xl-4 px-2xl-4 px-lg-3">
                <TextOnlyContainer
                  text={title}
                  classes="sns-h3 mobile-fs-18 navy-blue lh-1-point-5 same-size-title text-with-image-content-title"
                />
                <TextOnlyContainer
                  text={description}
                  classes="sns-h5 my-2 my-md-3 my-2xl-3 paragraph-spacing text-with-image-content-description"
                />
                <div className="links-block sns-h5 font-weight-bold text-uppercase my-2 mt-md-4 my-2xl-4 mb-md-0">
                  {get(doc, "items", []).map(({ url, url_text, start_an_order }, idx) => (
                    <span key={`program-link-${idx}`}>
                      {start_an_order && StartOrderBtn ? (
                        <StartOrderBtn className="program-link mr-md-4 mr-2xl-4 mr-3 ls-3">
                          {textResolver(url_text)}
                        </StartOrderBtn>
                      ) : (
                        url?.url && (
                          <PrismicLinkTag
                            urlText={url_text}
                            url={url?.url}
                            target={url?.target}
                            className="program-link ls-3 mr-md-4 mr-2xl-4 mr-3"
                          />
                        )
                      )}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-6 overflow-hidden text-with-image-media-block">
            {media?.url ? (
              <div
                className="d-flex align-items-center justify-content-center video-holder mobile-h-auto"
                style={{ height: `${useHeight}px`, width: `${useWidth}px` }}
              >
                <Multimedia
                  type="video"
                  alt=""
                  src={media.url}
                  lazy
                  className="img-fluid w-100"
                  height="100%"
                  width="100%"
                  controls
                />
              </div>
            ) : video?.html ? (
              <div
                className="d-flex align-items-center justify-content-center video-holder"
                dangerouslySetInnerHTML={{ __html: innerHTML }}
              />
            ) : (
              <div className="position-relative">
                {imgLink && (
                  <PrismicLinkTag
                    url={imgLink}
                    target={imgTarget}
                    className="program-link h-100 w-100 position-absolute"
                  />
                )}
                <PrismicImgix
                  alt={imgAlt}
                  src={imgSrc}
                  className="textModule2 w-100"
                  desktop="840px"
                  mobile="375px"
                  tablet="400px"
                  largeDisplay="1300px"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextWithLeftImage;
